import { groupConstants } from '../_constants/group.constants';

export const initialState = {
  errors: [],
  isSaving: false,
  collection: []
}

export function group(state = initialState, action) {
  if (action.type === groupConstants.GETALL_GROUPS_SUCCESS) {
    return {
      ...state,
      collection: action.collection
    }
  }

  return state;
}
